import React, { useState } from "react";
import { FormLabel } from "react-bootstrap";
import CoverPhotoBaseURL from "../../../shared/util/coverPhotoBaseURL";
import "./style.css";

function SingleBookDetailsCard({ src, left, right, item }) {
  return (
    <>
      {left && (
        <div className="book-details-card-title-container">
          <FormLabel className="book-details-card-title">Owned Book</FormLabel>
        </div>
      )}
      {right && (
        <div className="book-details-card-title-container">
          <FormLabel className="book-details-card-title">
            Offered Book
          </FormLabel>
        </div>
      )}
      <div className="modal-body modal-body-flex">
        <>
          <img
            src={`${CoverPhotoBaseURL}${item?.library?.coverimage}`}
            className="book-details-img2"
          />
          <div className="book-details-container2">
            <div>
              <FormLabel className="book-details-title2">
                {item?.library?.bookname}
              </FormLabel>
            </div>
            <div className="book-details-description-text2 ellipsis">
              <FormLabel className="book-details-description-text-concat2">
                {item?.library?.description}
              </FormLabel>
            </div>
            <div className="d-flex flex-row">
              <FormLabel className="mr-3 book-details-text-style2">
                Author:
              </FormLabel>
              <FormLabel className="book-details-text-style3">
                {item?.library?.writername}
              </FormLabel>
            </div>
            <div className="d-flex flex-row">
              <FormLabel className="mr-3 book-details-text-style2">
                Genre:
              </FormLabel>
              <FormLabel className="book-details-text-style3">
                {item?.library?.genre}
              </FormLabel>
            </div>
            <div className="d-flex flex-row">
              <FormLabel className="mr-3 book-details-text-style2">
                Publisher:
              </FormLabel>
              <FormLabel className="book-details-text-style3">
                {item?.library?.publisher?.firstname}{" "}
                {item?.library?.publisher?.lastname}
              </FormLabel>
            </div>
            <div className="d-flex flex-row">
              <FormLabel className="mr-3 book-details-text-style2">
                Price:
              </FormLabel>
              <FormLabel className="book-details-text-style3">
                ${item?.library?.price}
              </FormLabel>
            </div>
          </div>
        </>
      </div>
    </>
  );
}

export default SingleBookDetailsCard;
